import { SettingsDesktopView, type SettingsSection } from './SettingsDesktopView';
import type { User } from '../../auth/api';

export function SettingsMobileView(props: { section?: SettingsSection; user: User }) {
  return <SettingsDesktopView {...props} />;
}
